import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface TopBarCartData {
  totalQty: number;
  totalAmount: number;
  currencySymbol: string;
}

@Injectable({
  providedIn: 'root',
})
export class SiaTopBarCartService {
  private _cartData$ = new BehaviorSubject<TopBarCartData>({
    totalQty: 0,
    totalAmount: 0,
    currencySymbol: '€',
  });

  get cartData$(): Observable<TopBarCartData> {
    return this._cartData$.asObservable();
  }

  get cartData(): TopBarCartData {
    return this._cartData$.value;
  }

  updateCart(data: TopBarCartData): void {
    this._cartData$.next(data);
  }
}
